var map = {
	"./assets/css/sidebar-theme.css": "275a",
	"./assets/fonts/Gilroy/Gilroy-Black.ttf": "8dc6",
	"./assets/fonts/Gilroy/Gilroy-BlackItalic.ttf": "19cc",
	"./assets/fonts/Gilroy/Gilroy-Light.ttf": "54ce",
	"./assets/fonts/Gilroy/Gilroy-LightItalic.ttf": "a51d",
	"./assets/fonts/Gilroy/Gilroy-Regular.ttf": "ccbe",
	"./assets/fonts/Gilroy/Gilroy-RegularItalic.ttf": "0f26",
	"./assets/fonts/Gilroy/Gilroy-SemiBold.ttf": "31aa",
	"./assets/fonts/Gilroy/Gilroy-SemiBoldItalic.ttf": "b60d",
	"./assets/fonts/boxicons.eot": "f7b9",
	"./assets/fonts/boxicons.svg": "e1e2",
	"./assets/fonts/boxicons.ttf": "94550",
	"./assets/fonts/boxicons.woff": "3880",
	"./assets/fonts/boxicons.woff2": "25df",
	"./assets/fonts/dripicons-v2.eot": "4749",
	"./assets/fonts/dripicons-v2.svg": "38b8",
	"./assets/fonts/dripicons-v2.ttf": "027b",
	"./assets/fonts/dripicons-v2.woff": "8b31",
	"./assets/fonts/fa-brands-400.eot": "26d4",
	"./assets/fonts/fa-brands-400.svg": "ecf4",
	"./assets/fonts/fa-brands-400.ttf": "cdc5",
	"./assets/fonts/fa-brands-400.woff": "8621",
	"./assets/fonts/fa-brands-400.woff2": "7630",
	"./assets/fonts/fa-regular-400.eot": "b835",
	"./assets/fonts/fa-regular-400.svg": "347e",
	"./assets/fonts/fa-regular-400.ttf": "8757",
	"./assets/fonts/fa-regular-400.woff": "c2bf",
	"./assets/fonts/fa-regular-400.woff2": "e6ca",
	"./assets/fonts/fa-solid-900.eot": "ac48",
	"./assets/fonts/fa-solid-900.svg": "f074",
	"./assets/fonts/fa-solid-900.ttf": "32e7",
	"./assets/fonts/fa-solid-900.woff": "4626",
	"./assets/fonts/fa-solid-900.woff2": "79d5",
	"./assets/fonts/materialdesignicons-webfont.eot": "90af",
	"./assets/fonts/materialdesignicons-webfont.ttf": "4a57",
	"./assets/fonts/materialdesignicons-webfont.woff": "7bb8",
	"./assets/fonts/materialdesignicons-webfont.woff2": "4d7e",
	"./assets/fonts/summernote.eot": "79d7",
	"./assets/fonts/summernote.ttf": "9864",
	"./assets/fonts/summernote.woff": "f6d7",
	"./assets/icons/Arrow_circle_up_solid.svg": "504d",
	"./assets/icons/Overlay.svg": "a98d7",
	"./assets/icons/TN_marker_map-Design.svg": "9646",
	"./assets/icons/active.svg": "b3e7",
	"./assets/icons/add-circle-w.svg": "ced0",
	"./assets/icons/add-circle.svg": "8729",
	"./assets/icons/add-p.svg": "3b0b",
	"./assets/icons/add-s.svg": "001c",
	"./assets/icons/address-at.svg": "ae57",
	"./assets/icons/address.svg": "e8fc",
	"./assets/icons/analyse-svgrepo-com.svg": "f7c5",
	"./assets/icons/analytics-graph.svg": "ee55",
	"./assets/icons/analytics.svg": "f412",
	"./assets/icons/angle-down.svg": "fa03",
	"./assets/icons/angle-up.svg": "dca6",
	"./assets/icons/ar.svg": "3257",
	"./assets/icons/arrow-circle-up-p.svg": "1b0e",
	"./assets/icons/arrow-left-2-w.svg": "582a",
	"./assets/icons/arrow-left-black.svg": "1d62",
	"./assets/icons/arrow-left.svg": "ac3b",
	"./assets/icons/arrow-right-2-w.svg": "27bd",
	"./assets/icons/bag-w.svg": "3c5f",
	"./assets/icons/bag.svg": "47fd",
	"./assets/icons/bassic-badge.png": "566a",
	"./assets/icons/bassic-badge.svg": "39e3",
	"./assets/icons/bell-alt-ring-p.svg": "181d",
	"./assets/icons/bell-alt-ring.svg": "f11a",
	"./assets/icons/bill.svg": "5ac8",
	"./assets/icons/brand-adversal.svg": "5597",
	"./assets/icons/bread.svg": "3124",
	"./assets/icons/calander-w.svg": "e845",
	"./assets/icons/calendar-add.svg": "f193",
	"./assets/icons/calendar-w.svg": "a223",
	"./assets/icons/campaign.svg": "8872",
	"./assets/icons/capsules.svg": "940f",
	"./assets/icons/car-3-svgrepo-com.svg": "f0e6",
	"./assets/icons/cart-large-p.svg": "6e05",
	"./assets/icons/check-circle-s.svg": "a28e",
	"./assets/icons/check-circle-white.svg": "ba4a",
	"./assets/icons/check-circle.svg": "cfcb",
	"./assets/icons/check-double.svg": "4a52",
	"./assets/icons/check.svg": "7bae",
	"./assets/icons/checked.gif": "9c82",
	"./assets/icons/clean-table.svg": "5934",
	"./assets/icons/clock-circle-svgrepo-com.svg": "f405",
	"./assets/icons/close-danger.svg": "ed6f",
	"./assets/icons/close-dark.svg": "2c95",
	"./assets/icons/close.svg": "8b1b",
	"./assets/icons/cloud-upload.svg": "ecad",
	"./assets/icons/cogwheel-svgrepo-com.svg": "69bf",
	"./assets/icons/csvFile.svg": "4aa0",
	"./assets/icons/daily-calendar-svgrepo-com.svg": "ade6",
	"./assets/icons/danger-circle-warning.svg": "642c",
	"./assets/icons/data-folder-svgrepo-com.svg": "b410",
	"./assets/icons/data-line.svg": "d6c9",
	"./assets/icons/data-service.svg": "4c37",
	"./assets/icons/deal-svgrepo-com.svg": "95fb",
	"./assets/icons/delivered-box-verification.svg": "af57",
	"./assets/icons/delivery-date.svg": "2496",
	"./assets/icons/delivery-truck-error.svg": "53ff",
	"./assets/icons/delivery-truck-time.svg": "715b",
	"./assets/icons/delivery-truck.svg": "1062",
	"./assets/icons/delivery.svg": "4a78",
	"./assets/icons/disabled.svg": "6935",
	"./assets/icons/double-arrow-left-white.svg": "9c89",
	"./assets/icons/double-left-w.svg": "c037",
	"./assets/icons/double-right-w.svg": "35e4",
	"./assets/icons/down.svg": "d8aa",
	"./assets/icons/download.svg": "f28e",
	"./assets/icons/edit.svg": "daf0",
	"./assets/icons/email.svg": "43be",
	"./assets/icons/en.svg": "eff4",
	"./assets/icons/error.gif": "dfd9",
	"./assets/icons/error2.gif": "8c2b",
	"./assets/icons/event-log.svg": "9e10",
	"./assets/icons/facebook.svg": "8485",
	"./assets/icons/family-of-3-whole-body-svgrepo-com.svg": "dc9f",
	"./assets/icons/features/banner.svg": "7826",
	"./assets/icons/features/call.svg": "1306",
	"./assets/icons/features/dashboard.svg": "5040",
	"./assets/icons/features/data.svg": "9e0d",
	"./assets/icons/features/language.svg": "4612",
	"./assets/icons/features/menu.svg": "e82d",
	"./assets/icons/features/order.svg": "a60a",
	"./assets/icons/features/social.svg": "a4ad",
	"./assets/icons/fi-rr-cloud-upload.svg": "35e8",
	"./assets/icons/fidelity.svg": "67d8",
	"./assets/icons/find-location.svg": "0477",
	"./assets/icons/fr.svg": "7b8a",
	"./assets/icons/globe-no-svgrepo-com.svg": "db09",
	"./assets/icons/graph-svgrepo-com.svg": "0016",
	"./assets/icons/hands-helping.svg": "9c78",
	"./assets/icons/heart-full-red.svg": "d21a",
	"./assets/icons/heart-red.svg": "f51e",
	"./assets/icons/help.svg": "acc2",
	"./assets/icons/history-lock.svg": "d461",
	"./assets/icons/home-w.svg": "9659",
	"./assets/icons/home.svg": "ac9d",
	"./assets/icons/i1.png": "e48d",
	"./assets/icons/i2.png": "0da2",
	"./assets/icons/i3.png": "113b",
	"./assets/icons/image-w.svg": "605b",
	"./assets/icons/image.svg": "931c",
	"./assets/icons/info-circle-w.svg": "0055",
	"./assets/icons/info-circle.svg": "6668",
	"./assets/icons/info-custom.svg": "9dca",
	"./assets/icons/info.svg": "76ed",
	"./assets/icons/instagram-w.svg": "0098",
	"./assets/icons/instagram.svg": "bd6c",
	"./assets/icons/instam-arrow-left.svg": "95c0",
	"./assets/icons/left-2.svg": "3b76",
	"./assets/icons/m1.png": "4208",
	"./assets/icons/m2.png": "05f6",
	"./assets/icons/m3.png": "72e6",
	"./assets/icons/m4.png": "a8f4",
	"./assets/icons/m5.png": "210e",
	"./assets/icons/machinery.svg": "ca8f",
	"./assets/icons/map-point-rotate.svg": "bc38",
	"./assets/icons/map.svg": "0443",
	"./assets/icons/marker-near.svg": "312d",
	"./assets/icons/marker.png": "6ae8",
	"./assets/icons/menu-dots-w.svg": "eabc",
	"./assets/icons/menu.svg": "d17f",
	"./assets/icons/minus-circle.svg": "4ade",
	"./assets/icons/minus-p.svg": "05d1",
	"./assets/icons/minus-s.svg": "3f53",
	"./assets/icons/multiImages.svg": "a942",
	"./assets/icons/near.svg": "e9e5",
	"./assets/icons/next.svg": "0043",
	"./assets/icons/notes-s.svg": "0cdd",
	"./assets/icons/pencil.svg": "e51f",
	"./assets/icons/pharmaMarker.png": "c9d2",
	"./assets/icons/phone.svg": "c3bb",
	"./assets/icons/plane-svgrepo-com.svg": "5fad",
	"./assets/icons/premium-badge-gold.svg": "69a8",
	"./assets/icons/print.svg": "671e",
	"./assets/icons/printer.svg": "345d",
	"./assets/icons/promotion.svg": "7247",
	"./assets/icons/qr-code-interactive.svg": "d2a2",
	"./assets/icons/qr-icon.svg": "84fb",
	"./assets/icons/qrc.svg": "41f2",
	"./assets/icons/question-circle.svg": "1f28",
	"./assets/icons/recipt.svg": "5354",
	"./assets/icons/recycling-recycle.svg": "f5fd",
	"./assets/icons/refresh-circle-white.svg": "a42e",
	"./assets/icons/refresh-warning.svg": "97da",
	"./assets/icons/refresh.svg": "53fa",
	"./assets/icons/right-2.svg": "5999",
	"./assets/icons/right.svg": "37af",
	"./assets/icons/send-hor.svg": "7ee4",
	"./assets/icons/setting-line.svg": "d8c2",
	"./assets/icons/setting-s.svg": "62a2",
	"./assets/icons/settings.svg": "9174",
	"./assets/icons/share-icon.svg": "c4ad",
	"./assets/icons/share-svgrepo-com.svg": "48cd",
	"./assets/icons/sign-out.svg": "8e2f",
	"./assets/icons/smart-home-angle-svgrepo-com.svg": "c11a",
	"./assets/icons/star-s.svg": "f8c8",
	"./assets/icons/starRate.svg": "9d06",
	"./assets/icons/status.svg": "c10e",
	"./assets/icons/stopwatch.svg": "aac5",
	"./assets/icons/target-2-svgrepo-com.svg": "2d92",
	"./assets/icons/target-and-arrow-svgrepo-com.svg": "aedc",
	"./assets/icons/tn-map.svg": "773c",
	"./assets/icons/transfer.svg": "f62e",
	"./assets/icons/trash-p.svg": "ef29",
	"./assets/icons/trash.svg": "af22",
	"./assets/icons/tray-dish-svgrepo-com.svg": "4d25",
	"./assets/icons/twitter.svg": "acf9",
	"./assets/icons/user-alt.svg": "9039",
	"./assets/icons/user-g.svg": "4028",
	"./assets/icons/user-p.svg": "4e1e",
	"./assets/icons/user.svg": "6aed",
	"./assets/icons/users-2-svgrepo-com.svg": "b1b6",
	"./assets/icons/users.svg": "d956",
	"./assets/icons/waiter-j.svg": "a85c",
	"./assets/icons/waiter-w.svg": "01de",
	"./assets/icons/waiter.svg": "6f0b",
	"./assets/icons/whatsapp.svg": "7583",
	"./assets/images/Boulangerie.jpg": "0d6e",
	"./assets/images/Pharmacie.jpg": "9828",
	"./assets/images/Spoon-fork-knife-icon.png": "1350",
	"./assets/images/atout.png": "6469",
	"./assets/images/back.jpg": "e857",
	"./assets/images/background/ImageBackground1.png": "b608",
	"./assets/images/background/ImageBackground2.png": "d0d2",
	"./assets/images/background/ImageBackground3.png": "bf85",
	"./assets/images/background/back.png": "8ce7",
	"./assets/images/background/pubag-back.png": "8083",
	"./assets/images/bagsBa.png": "1726",
	"./assets/images/bakery-bags-prime.png": "b883",
	"./assets/images/bakery-bags.png": "fdac",
	"./assets/images/become-partner-banner.jpg": "7467",
	"./assets/images/chevron-down.png": "0fc3",
	"./assets/images/contact-us-img.jpg": "c9bf",
	"./assets/images/dashboard.png": "a6231",
	"./assets/images/digitable-menu.png": "0ad2",
	"./assets/images/digitable-platforme-old.png": "c88f",
	"./assets/images/digitable-platforme.png": "1226",
	"./assets/images/exemple4.png": "54dd",
	"./assets/images/features/banner.png": "2ccf",
	"./assets/images/features/call.png": "8c0e",
	"./assets/images/features/dashboard.png": "ed31",
	"./assets/images/features/data.png": "109a",
	"./assets/images/features/language.png": "22e9",
	"./assets/images/features/menu.png": "7977",
	"./assets/images/features/order.png": "ecfa",
	"./assets/images/features/social.png": "77b2",
	"./assets/images/header-logo.png": "62e7",
	"./assets/images/logo-mini.png": "a2c8",
	"./assets/images/logo-white.png": "06f1",
	"./assets/images/logo.png": "9d64",
	"./assets/images/mr-sushi/club.png": "f21d",
	"./assets/images/mr-sushi/cover.jpg": "8d9f",
	"./assets/images/mr-sushi/facebook.png": "68a6",
	"./assets/images/mr-sushi/google-review.png": "cb3d",
	"./assets/images/mr-sushi/instagram.png": "fe20",
	"./assets/images/mr-sushi/menu.png": "1954",
	"./assets/images/mr-sushi/profile.jpg": "01bb",
	"./assets/images/mr-sushi/tripadvisor.png": "01f2",
	"./assets/images/pharma-bags-prime.png": "aa02",
	"./assets/images/pharma-bags.png": "3312",
	"./assets/images/pubag-logo.png": "6967",
	"./assets/images/references/1.png": "c2ef",
	"./assets/images/references/10.png": "81e7",
	"./assets/images/references/11.png": "7aca",
	"./assets/images/references/12.png": "c96f",
	"./assets/images/references/13.png": "d93b",
	"./assets/images/references/14.png": "714e",
	"./assets/images/references/15.png": "ec35",
	"./assets/images/references/16.png": "ddf1",
	"./assets/images/references/17.png": "1993",
	"./assets/images/references/18.png": "ed56",
	"./assets/images/references/2.png": "3164",
	"./assets/images/references/3.png": "287b",
	"./assets/images/references/4.png": "3812",
	"./assets/images/references/5.png": "c165",
	"./assets/images/references/6.png": "6f9e",
	"./assets/images/references/7.png": "e656",
	"./assets/images/references/8.png": "20dd",
	"./assets/images/references/9.png": "b6f7",
	"./assets/images/rubon78.jpg": "238b",
	"./assets/images/sac-pharmacie.jpg": "f14d",
	"./assets/images/sm-logo.png": "7c51",
	"./assets/images/team-map-position.png": "a52a",
	"./assets/images/tunisia-flag.svg": "4ad2",
	"./assets/sounds/restaurant-bell.mp3": "b975"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53a4";